import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import DevContent from './DevContent'
import FieldTypes from './BackdoorCommonComponents/FieldTypes'
import config from '../../Shared/config'
import Axios from 'axios'

export default class DevContentContainer extends Component {

    constructor(props) {
        super(props)

        this.state = {
            routes: [
                {
                    routeId: 'teacher',
                    title: 'Teachers',
                    to: '/backdoor/teachers',
                    apiUrl: `${config.apiUrl}/Teacher`,
                    useGenericSave: false,
                    onClickSave: this.saveTeacher,
                    pageFields: [
                        {
                            id: 'firstName',
                            name: 'firstName',
                            label: 'First Name',
                            type: FieldTypes.alpha,
                            inGrid: true,
                            gridDisplayOrder: 1,
                            newDisplayOrder: 1,
                            validations: {
                                required: true,
                            }
                        },
                        {
                            id: 'lastName',
                            name: 'lastName',
                            label: 'Last Name',
                            type: FieldTypes.alpha,
                            inGrid: true,
                            gridDisplayOrder: 2,
                            newDisplayOrder: 1
                        },
                        {
                            id: 'age',
                            name: 'age',
                            label: 'Age',
                            type: FieldTypes.number,
                            inGrid: true,
                            gridDisplayOrder: 3,
                            newDisplayOrder: 1
                        },
                        {
                            id: 'userName',
                            name: 'userName',
                            label: 'User Name',
                            type: FieldTypes.alphanumeric,
                            inGrid: true,
                            gridDisplayOrder: 4,
                            newDisplayOrder: 1
                        },
                        {
                            id: 'email',
                            name: 'email',
                            label: 'Email',
                            type: FieldTypes.email,
                            inGrid: true,
                            gridDisplayOrder: 5,
                            newDisplayOrder: 1
                        },
                        {
                            id: 'description',
                            name: 'description',
                            label: 'Description',
                            type: FieldTypes.alpha,
                            inGrid: true,
                            gridDisplayOrder: 6,
                            newDisplayOrder: 1
                        },
                        {
                            id: 'teachingExperience',
                            name: 'teachingExperience',
                            label: 'Teaching Experience',
                            type: FieldTypes.number,
                            inGrid: true,
                            gridDisplayOrder: 7,
                            newDisplayOrder: 1
                        },
                        {
                            id: 'practiceExperience',
                            name: 'practiceExperience',
                            label: 'Practice Experience',
                            type: FieldTypes.number,
                            inGrid: true,
                            gridDisplayOrder: 8,
                            newDisplayOrder: 1
                        },
                        {
                            id: 'numberOfStudentsTaught',
                            name: 'numberOfStudentsTaught',
                            label: 'Students Taught',
                            type: FieldTypes.number,
                            inGrid: true,
                            gridDisplayOrder: 9,
                            newDisplayOrder: 1
                        },
                        {
                            id: 'teacherCharacteristics',
                            name: 'teacherCharacteristics',
                            label: 'Teacher Characteristics (comma separated)',
                            type: FieldTypes.alpha,
                            inGrid: true,
                            gridDisplayOrder: 10,
                            newDisplayOrder: 1
                        },
                        {
                            id: 'profileImage',
                            name: 'profileImage',
                            label: 'Profile Image',
                            type: FieldTypes.singleImage,
                            inGrid: true,
                            gridDisplayOrder: 11,
                            newDisplayOrder: 1
                        },
                    ]
                },
                {
                    routeId: 'student',
                    title: 'Students',
                    to: '/backdoor/students',
                    apiUrl: `${config.apiUrl}/Teacher/getall?skip=0`,
                    useGenericSave: true,
                    pageFields: [
                        {
                            id: 'firstName',
                            name: 'firstName',
                            label: 'First Name',
                            type: FieldTypes.alpha,
                            inGrid: true,
                            gridDisplayOrder: 1,
                            newDisplayOrder: 1,
                            validations: {
                                required: true,
                            }
                        },
                        {
                            id: 'lastName',
                            name: 'lastName',
                            label: 'Last Name',
                            type: FieldTypes.alpha,
                            inGrid: true,
                            gridDisplayOrder: 2,
                            newDisplayOrder: 1
                        },
                        {
                            id: 'age',
                            name: 'age',
                            label: 'Age',
                            type: FieldTypes.number,
                            inGrid: true,
                            gridDisplayOrder: 3,
                            newDisplayOrder: 1
                        },
                        {
                            id: 'userName',
                            name: 'userName',
                            label: 'User Name',
                            type: FieldTypes.alphanumeric,
                            inGrid: true,
                            gridDisplayOrder: 4,
                            newDisplayOrder: 1
                        },
                        {
                            id: 'email',
                            name: 'email',
                            label: 'Email',
                            type: FieldTypes.email,
                            inGrid: true,
                            gridDisplayOrder: 5,
                            newDisplayOrder: 1
                        },
                        {
                            id: 'description',
                            name: 'description',
                            label: 'Description',
                            type: FieldTypes.alpha,
                            inGrid: true,
                            gridDisplayOrder: 6,
                            newDisplayOrder: 1
                        },
                    ]
                },
                {
                    routeId: 'listing',
                    title: 'Listings',
                    to: '/backdoor/listings',
                    apiUrl: `${config.apiUrl}/Listing`,
                    useGenericSave: true,
                    pageFields: [
                        {
                            id: 'listingTitle',
                            name: 'listingTitle',
                            label: 'Title',
                            type: FieldTypes.alphanumeric,
                            inGrid: true,
                            gridDisplayOrder: 1,
                            newDisplayOrder: 1,
                            validations: {
                                required: true,
                            }
                        },
                        {
                            id: 'sessionPrice',
                            name: 'sessionPrice',
                            label: 'Session Price',
                            type: FieldTypes.number,
                            inGrid: true,
                            gridDisplayOrder: 2,
                            newDisplayOrder: 1
                        },
                        {
                            id: 'listingDescription',
                            name: 'listingDescription',
                            label: 'Description',
                            type: FieldTypes.alphanumeric,
                            inGrid: true,
                            gridDisplayOrder: 3,
                            newDisplayOrder: 1
                        },
                        {
                            id: 'teacherName',
                            name: 'teacherName',
                            label: 'Teacher Name',
                            type: FieldTypes.dropdown,
                            schema: 'Teacher',
                            column: 'firstName, lastName',
                            separator: ' ',
                            getDataFromServer: true,
                            inGrid: true,
                            gridDisplayOrder: 4,
                            newDisplayOrder: 1
                        },
                        {
                            id: 'classTaught',
                            name: 'classTaught',
                            label: 'Class Taught',
                            type: FieldTypes.dropdown,
                            getDataFromServer: false,
                            inGrid: true,
                            gridDisplayOrder: 5,
                            newDisplayOrder: 1,
                            options: [
                                { id: 6, label: '6th' },
                                { id: 7, label: '7th' },
                                { id: 8, label: '8th' },
                                { id: 9, label: '9th' },
                                { id: 10, label: '10th' },
                            ]
                        },
                        {
                            id: 'city',
                            name: 'city',
                            label: 'City',
                            type: FieldTypes.dropdown,
                            getDataFromServer: false,
                            inGrid: true,
                            gridDisplayOrder: 6,
                            newDisplayOrder: 1,
                            options: [
                                { id: 1, label: 'Gurgaon' },
                                { id: 2, label: 'Delhi' },
                                { id: 3, label: 'Chandigarh' },
                                { id: 4, label: 'Meerut' },
                                { id: 5, label: 'Lahore' },
                            ]
                        },
                        {
                            id: 'packageInformation',
                            name: 'packageInformation',
                            label: 'Package Information',
                            type: FieldTypes.alphanumeric,
                            inGrid: true,
                            gridDisplayOrder: 7,
                            newDisplayOrder: 1
                        },
                        {
                            id: 'packagePrice',
                            name: 'packagePrice',
                            label: 'Package Price',
                            type: FieldTypes.number,
                            inGrid: true,
                            gridDisplayOrder: 8,
                            newDisplayOrder: 1
                        },
                        {
                            id: 'slots',
                            name: 'slots',
                            label: 'Slots',
                            type: FieldTypes.alphanumeric,
                            inGrid: true,
                            gridDisplayOrder: 9,
                            newDisplayOrder: 1
                        },
                        {
                            id: 'active',
                            name: 'active',
                            label: 'Active',
                            type: FieldTypes.radiolist,
                            inGrid: true,
                            gridDisplayOrder: 10,
                            newDisplayOrder: 1,
                            options: [
                                { id: 'Yes', label: 'Yes' },
                                { id: 'No', label: 'No' },
                            ]
                        },
                    ]
                },
            ]
        }
    }

    saveTeacher = (formData, files, redirect) => {
        console.log(formData)
        this.saveImage(files?.profileImage).then(imageRes => {
            formData.profileImageUrl = imageRes.data.data
            console.log(formData)
            const url = `${config.apiUrl}/Teacher/add`;
            Axios.post(url, formData).then(res => {
                if (!res.data.error) {
                    alert(res.data.message)
                    redirect()
                } else {
                    alert(res.data.message)
                }
            }).catch(err => {
                console.error(err)
            })
        })
    }

    saveImage = (profileImage) => {
        const url = `${config.apiUrl}/Teacher/saveImage`;
        let data = new FormData();
        data.append('image', profileImage, profileImage.name)
        return Axios.post(url, data).then(res => {
            return res
        }).catch(err => {
            console.error(err)
        })
    }

    render() {
        return (
            <div className="dev-dashboard__content">
                <Switch>
                    <Route path={'/backdoor/'} exact render={() => <div>Home</div>} />
                    {
                        this.state.routes.map((item, idx) => {
                            return (
                                <Route key={idx} path={item.to} render={(props) =>
                                    <DevContent
                                        {...item}
                                        {...props}
                                    />}
                                />
                            )
                        })
                    }
                </Switch>
            </div>
        )
    }
}
